<script setup>
  import {ref} from "vue";

  import ComponentButton from "@components/Buttons/Button.vue";
  import ComponentDialog from "@components/Dialogs/Dialog.vue";
  import {MedButton} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "CryptDialogsError",
  });

  defineProps({
    privacy: {
      type: Object,
      required: true,
    },
  });

  const refCryptDialog = ref(null);

  const open = () => {
    refCryptDialog.value.open();
  };

  const close = () => {
    refCryptDialog.value.close();
  };

  const reload = () => {
    location.reload();
  };

  defineExpose({
    open,
    close,
  });
</script>

<template>
  <ComponentDialog ref="refCryptDialog" dialog-width="medium" :test-id="getTestId('error')">
    <template #title>Datenschutzpasswort</template>

    <template #content>
      <p :data-test="getTestId('error-dialog-message')">{{ privacy.getErrorMessage() }}</p>
    </template>

    <template #actions>
      <MedButton variant="primary" :data-test="getTestId('error-dialog-reload-button')" @click="reload()">
        Abbrechen
      </MedButton>

      <component-button
        class="p4umc-primary"
        label="Abbrechen"
        :test-id="getTestId('error-dialog-reload')"
        @click="reload()"
      />
    </template>
  </ComponentDialog>
</template>
